import {createSelector} from '@reduxjs/toolkit';
import {selectDomain} from '.';
import {ObjectId} from 'types/object-id';

export default (id: ObjectId) =>
  createSelector([selectDomain], domain => {
    return !!domain.expandedProducts[id]?.id;
  });
